import * as Yup from "yup";
import { validateCharacterLimitWithContext } from "../../../helpers/formBodyCharacterLimitValidation";

export const schema = Yup.object().shape({
  title: Yup.string().required("Debes indicar el nombre de la artículo."),
  body: Yup.string()
    .nullable()
    .required("Agrega una descripción a tu artículo.")
    .test(
      'character-limit',
      'No puedes usar más de caracteres', // El mensaje se maneja dinámicamente en la función
      function (value) {
        return validateCharacterLimitWithContext.call(this, value, 10000); // 1000 caracteres máximo
      }
    ),
  cover_pic: Yup.array().nullable(),
  attached_files: Yup.array().nullable(),
  attached_url: Yup.string().nullable(),
  block_files_download: Yup.array().of(Yup.string()).nullable(),
});

interface FormValues {
  title: string;
  body: string;
  cover_pic?: object[];
  attached_files?: object[];
  attached_url?: string;
  block_files_download: string[]
}

export const initialValues: FormValues = {
  title: "",
  body: "",
  block_files_download: []
};
